module.exports = __webpack_public_path__ + "media/images/flags/16/Pakistan-c0d6cb8aae43b050b76f0d02673e0567.png";